import React from 'react';
import DashboardIcon from "@mui/icons-material/Dashboard";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import TableViewIcon from '@mui/icons-material/TableView';

const MUI_ICON_TYPE = {
  dashboard: DashboardIcon,
  assign_ind: AssignmentIndIcon,
  timelapse: TimelapseIcon,
  new_releases: NewReleasesIcon,
  menu_open: MenuOpenIcon,
  table_view: TableViewIcon
};

export const FaIcon = ({type, className = "", ...rest}) => (
  <i className={`fa fa-${type} ${className}`} {...rest} />
) 

export const Glyphicon = ({type, className = "", ...rest}) => (
  <span className={`glyphicon glyphicon-${type} ${className}`} {...rest} />
) 

export const Adalicon = ({type, className = "", ...rest}) => (
  <span className={`adalicon icon-${type} ${className}`} {...rest} />
)

export const ChartIcon = ({type, className = "", ...rest}) => (
  <img src={`/images/charticons/${type}.svg`} alt={type} className={className} {...rest} />
)

export const MuiIcon = ({ type, className = "", ...rest }) => (
  React.createElement(MUI_ICON_TYPE[type.toLowerCase()], { className: `mui-icon ${className}` , ...rest })
)